import { render, staticRenderFns } from "./FormParcourscliniquecreate.vue?vue&type=template&id=71ef8b70&"
import script from "./FormParcourscliniquecreate.vue?vue&type=script&lang=js&"
export * from "./FormParcourscliniquecreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports